export default "__VITE_ASSET__hoHgoDGc__"